export default __webpack_public_path__ + "static/media/sadFaceV2.96aa57f2.svg";